import { UNCAUGHT_ERROR } from '@shared/libs/errors-consts';
import { ErrorLayout } from '@shared/layouts/ErrorLayout';
import { FC } from 'react';

export const ErrorPageUncaughtError: FC = () => {
  return <ErrorLayout error={UNCAUGHT_ERROR} showBasicButton={false} />;
};
